import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_9: FaireProductEntity = {
  token: "sweet-wink-9",
  type: "product",
  name: "Coquette Christmas Tree Knit Women's Sweater - Mommy and Me",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/f6848bbea966e0a15b790a04041e8181742ed6bf5f0d2655303f283e8abc37c1.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1079,1079,x0,y0,safe&width=720",
  priceDollars: 24,
  msrpDollars: 48,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
